import { useEffect, useState } from 'react';
import Select from 'react-select';
import eventsApi from 'api/requests/events';
import establishmentsApi from 'api/requests/establishments';

export default function EstablishmentEventSelector({
    establishment,
    onEventSelected = () => {}
}) {
    const [availableEvents, setAvailableEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);

    const findActiveEvent = async (establishmentSlug) => {
        try {
            const { data } = await establishmentsApi.findActiveEvent(establishmentSlug);

            return data;
        } catch (error) {
            console.error(error);
        }
    };

    const getAvailableEvents = async () => {
        const { data: { data: availableEvents } } = await eventsApi.getByEstablishmentId(establishment?.id);
        const activeEvent = await findActiveEvent(establishment?.slug);
        let defaultSelectedEvent = availableEvents[0];

        if (activeEvent && activeEvent.slug) {
            defaultSelectedEvent = availableEvents.find(event => event.slug === activeEvent.slug);

            if (!defaultSelectedEvent) {
                defaultSelectedEvent = activeEvent;
                availableEvents.push(activeEvent);
            }
        }
        
        setAvailableEvents(availableEvents);
        setSelectedEvent(defaultSelectedEvent);
        onEventSelected(defaultSelectedEvent);
    };

    const handleSelectEvent = (event) => {
        setSelectedEvent(event);
        onEventSelected(event);
    };

    useEffect(() => {
        getAvailableEvents();
    }, []);
    return (
        <>
            <Select
                placeholder='Selecione um evento'
                value={selectedEvent}
                options={availableEvents}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.slug}
                onChange={handleSelectEvent}
            />
        </>
    );
}